import { h } from 'preact';
import { SkeletonBar } from '../SkeletonBar';
import type { ComponentShowcase } from '../registry';

export const showcase: ComponentShowcase = {
  name: 'SkeletonBar',
  category: '⏳ Loading',
  description: 'Barra de skeleton shimmer com largura e altura customizáveis',
  usedIn: ['PageShell', 'CardSkeleton', 'ListSkeleton', 'TableSkeleton'],
  example: () => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <SkeletonBar width="80%" height={14} />
      <SkeletonBar width="60%" height={10} />
      <SkeletonBar width="40%" height={20} />
    </div>
  ),
};
